import { BadgePercent } from "lucide-react";
import { useActivePromotion } from "@/hooks/useActivePromotion";

const fmtPct = (p) => (Number.isInteger(Number(p)) ? String(p) : Number(p).toFixed(1));

const endsText = (promo) => {
  if (promo.end_time) return `until ${promo.end_time}`;
  if (promo.ends_at) {
    const d = new Date(promo.ends_at);
    const today = new Date();
    const sameDay = d.toDateString() === today.toDateString();
    return sameDay ? `until ${d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}` : `through ${d.toLocaleDateString([], { month: "short", day: "numeric" })}`;
  }
  return "applied automatically at checkout";
};

/** Storefront ribbon announcing the live site-wide promotion. Renders nothing when there isn't one. */
export function PromoBanner({ compact = false }) {
  const promo = useActivePromotion("online");
  if (!promo) return null;
  return (
    <div className={`mx-4 ${compact ? "mt-2" : "mt-3"} rounded-2xl bg-brand-yellow text-stone-900 px-4 py-2.5 flex items-center gap-3 shadow-[0_6px_20px_rgba(241,196,15,0.35)]`} data-testid="promo-banner">
      <BadgePercent className="w-6 h-6 shrink-0" />
      <div className="min-w-0">
        <div className="font-black text-sm uppercase tracking-widest leading-tight" data-testid="promo-banner-title">{fmtPct(promo.percent)}% off your whole order</div>
        <div className="text-xs font-semibold opacity-80 truncate">{promo.name} · {endsText(promo)}</div>
      </div>
    </div>
  );
}
